// Helpers for turning school-supplied website values into safe outbound links.

const SAFE_PROTOCOLS = ['http:', 'https:'];

/**
 * Normalize a website value into an absolute, safe https URL.
 * "queensschool.com" -> "https://queensschool.com"
 * Returns null when the value is empty or cannot be trusted as a web link.
 */
export const normalizeWebsiteUrl = (rawWebsite) => {
  if (typeof rawWebsite !== 'string') return null;

  const value = rawWebsite.trim();
  if (!value) return null;

  // Protocol-relative ("//example.com") and bare domains both become https.
  let candidate = value;
  if (candidate.startsWith('//')) {
    candidate = `https:${candidate}`;
  } else if (!/^[a-z][a-z0-9+.-]*:/i.test(candidate)) {
    candidate = `https://${candidate}`;
  }

  let url;
  try {
    url = new URL(candidate);
  } catch (error) {
    return null;
  }

  // Blocks javascript:, data:, mailto: and friends.
  if (!SAFE_PROTOCOLS.includes(url.protocol)) return null;

  // A hostname without a dot (e.g. "localhost" or a typo) is not a public site.
  if (!url.hostname.includes('.')) return null;

  return url.toString();
};

/** Short, human friendly label for a website link ("queensschool.com/admissions"). */
export const formatWebsiteLabel = (rawWebsite) => {
  const normalized = normalizeWebsiteUrl(rawWebsite);
  if (!normalized) return null;

  const url = new URL(normalized);
  const host = url.hostname.replace(/^www\./, '');
  const path = url.pathname === '/' ? '' : url.pathname.replace(/\/$/, '');

  return `${host}${path}`;
};
